import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

const Ecommerceshopify = () => {
  return (
    <div
      className="ecommerce_app_design p-100"
      style={{ background: "#F6F6F6" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="banenr_content">
              <h2>Ecommerce App Shopify/Drop shipping Integration</h2>
              <p>
                Tekrevol understands the growing needs of the digital market and
                offers solutions to meet them all. So no matter whether you are
                running a large Ecommerce business or a standalone dropshipping
                professional, you can get your Ecommerce application development
                done from us and get custom Shopify or Dropshipping based
                features laced in your app.
              </p>
            </div>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Get Started
            </Link>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-lg-1"
          >
            <StaticImage
              src="../../../images/solution/ecommerce/Drop-shippin.webp"
              alt="Ecommerce App"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={775}
              height={650}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Ecommerceshopify;
